// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import IconClose from "@conklin/XDL/Icons/IconClose";
import IconHeaderCaretLeft from "@conklin/XDL/Icons/IconHeaderCaretLeft";
import IconHeaderCaretRight from "@conklin/XDL/Icons/IconHeaderCaretRight";
import { color } from "@conklin/XDL/Utilities";
import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";

/* stylelint-disable */
const PanelMenuDefaultProps: ComponentThemeProps["panelMenu"]["defaultProps"] = {
    headerColor: "common.backgroundContrast",
    bodyColor: "common.ui1",
    childTypographyProps: {
        css: css`
            display: block;
            word-wrap: break-word;
            width: 100%;
        `,
    },
    backIconProps: {
        src: IconHeaderCaretLeft,
        size: 14,
        color: "common.ui4",
        css: css`
            &,
            svg {
                width: auto;
            }
        `,
    },
    closeIconProps: { src: IconClose },
    panelRowProps: {
        color: "common.ui1",
        moreIconProps: {
            src: IconHeaderCaretRight,
            size: 14,
            css: css`
                color: ${color("common.ui4")};
                height: 20px;
                justify-content: flex-end;
                &,
                svg {
                    width: auto;
                }
            `,
        },
    },
};
/* stylelint-enable */

export default PanelMenuDefaultProps;
